(() => {
  const initialize = (scope = document) => {
    const roots = scope.matches?.('[data-section-type="product"]') ? [scope] : scope.querySelectorAll('[data-section-type="product"]');
    roots.forEach((section) => {
      if (section.dataset.mobileToolsReady) return;
      section.dataset.mobileToolsReady = 'true';
      const nav = section.querySelector('.Product__SlideshowMobileNav');
      const counter = nav?.querySelector('[data-mobile-gallery-counter]');
      const bar = section.querySelector('[data-mobile-product-action]');
      const button = bar?.querySelector('[data-mobile-product-return]');
      const form = section.querySelector('.ProductForm');
      const browse = section.querySelector('[data-sold-recovery-browse]');
      const target = button?.dataset.available === 'true' ? form : browse;
      const mobile = matchMedia('(max-width: 640px)');
      const controller = new AbortController();
      const options = { passive: true, signal: controller.signal };
      let pending = false;
      let stopped = false;
      const updateCounter = () => {
        if (!counter || !nav) return;
        const dots = Array.from(nav.querySelectorAll('.dot'));
        const index = Math.max(0, dots.findIndex((dot) => dot.classList.contains('is-selected')));
        const value = `${index + 1} / ${dots.length}`;
        if (counter.textContent !== value) counter.textContent = value;
        counter.setAttribute('aria-label', counter.dataset.label.replace('__index__', String(index + 1)));
      };
      const update = () => {
        pending = false;
        if (stopped) return;
        updateCounter();
        if (!bar || !target) return;
        const rect = target.getBoundingClientRect();
        const preview = document.querySelector('#PBarNextFrameWrapper, #preview-bar-iframe');
        const previewRect = preview?.getBoundingClientRect();
        const offset = previewRect && previewRect.height > 0 && previewRect.top < innerHeight ? Math.max(0, innerHeight - previewRect.top) : 0;
        bar.style.setProperty('--mobile-product-preview-offset', `${offset}px`);
        const overlay = document.querySelector('.Drawer[aria-hidden="false"], .Modal[aria-hidden="false"], .pswp--open, [data-enquiry-details][open]');
        const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
        const hide = !mobile.matches || rect.bottom >= 0 || Boolean(overlay) || editing;
        if (bar.hidden !== Boolean(hide)) bar.hidden = Boolean(hide);
        const price = section.querySelector('.ProductMeta__Price:not(.Price--compareAt)');
        const barPrice = bar.querySelector('[data-mobile-product-price]');
        if (barPrice && price && barPrice.textContent !== price.textContent.trim()) barPrice.textContent = price.textContent.trim();
      };
      const schedule = () => {
        if (!pending && !stopped) { pending = true; requestAnimationFrame(update); }
      };
      button?.addEventListener('click', () => {
        if (!target) return;
        if (button.dataset.available !== 'true') { browse.click(); return; }
        const top = target.getBoundingClientRect().top + scrollY - 85;
        window.scrollTo({ top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        const original = form.querySelector('[data-action="add-to-cart"], button[type="submit"]');
        original?.focus({ preventScroll: true });
      }, { signal: controller.signal });
      const navObserver = new MutationObserver(schedule);
      if (nav) navObserver.observe(nav, { subtree: true, attributes: true, attributeFilter: ['class'] });
      const overlayObserver = new MutationObserver((records) => {
        if (records.some((record) => record.attributeName !== 'class' || record.target.matches('.Drawer,.Modal,.pswp'))) schedule();
      });
      overlayObserver.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'open', 'class'] });
      window.addEventListener('scroll', schedule, options);
      window.addEventListener('resize', schedule, options);
      document.addEventListener('focusin', schedule, { signal: controller.signal });
      document.addEventListener('focusout', schedule, { signal: controller.signal });
      section.addEventListener('variant:changed', schedule, { signal: controller.signal });
      section.classList.add('Product--mobile-enhanced');
      update();
      section.addEventListener('shopify:section:unload', () => {
        stopped = true;
        controller.abort();
        navObserver.disconnect();
        overlayObserver.disconnect();
      }, { once: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
